import { PanelCollapse } from '@bepure/tarkin';
import * as React from 'react';
import * as ReactDOM from 'react-dom';

interface PanelCollapseParams {
    question: string;
    answer: string;
}

interface CategoryPanelParams {
    title: string;
    faq: PanelCollapseParams[];
}

export const showCategoryPanel = (params: CategoryPanelParams[], element: Element) => {
    const components = (
        params.map((panel, i) =>
            (
                <PanelCollapse key={i} title={panel.title} isCategoryPanel={true}>
                    {panel.faq.map((item, index) =>
                        <PanelCollapse key={index} title={item.question}>
                            <div dangerouslySetInnerHTML={{ __html: item.answer || '' }} />
                        </PanelCollapse>)}
                </PanelCollapse>
            ),
        )
    );
    ReactDOM.render(components, element);
};
